module.exports = __webpack_public_path__ + "img/logo-insis.0b452b77.png";